<bspk-form-field [controlId]="controlId()"
                 [errorMessage]="errorMessage() || errorState()"
                 [helperText]="helperText()"
                 [label]="label()"
                 [required]="required()"
>
  <bspk-text-input [controlId]="controlId()"
                   [disabled]="disabled()"
                   [label]="label()"
                   [leading]="leading()"
                   [mask]="mask()"
                   [placeholder]="placeholder()"
                   [readOnly]="readOnly()"
                   [required]="required()"
                   [size]="size()"
                   [trailing]="trailing()"
                   [type]="type()"
                   [value]="value()"
                   (blur)="handleBlur($event)"
                   (focusin)="handleFocusin($event)"
                   (input)="handleInput($event)"
  />
</bspk-form-field>
